import { apiClient } from "../config/api.config";
import i18n from "../i18n";
import { getAcceptedLanguageCode } from "../utils/config-utils";

export function getSpecialties() {
  const currentLanguage = i18n.language || "fr";
  const acceptedLanguage = getAcceptedLanguageCode(currentLanguage);

  return apiClient.request({
    method: "get",
    url: `/specialties`,
    headers: {
      "Accept-Language": acceptedLanguage,
    },
  });
}
